import React from 'react'
import Page from '~/components/Page.jsx'
import { Typography, Grid } from '@material-ui/core/'
import AppToolBar from '~/components/AppToolBar.jsx'
import JSONLDHead from '~/components/JSONLDHead'
import Question from '~/components/faq/Question'
import EmailLink from '~/components/faq/EmailLink'
import { JSONLD_TYPE, JSX_TYPE } from '~/constant'
import { jsonLDHelpers } from '~/utils/jsonLD'
import useStyles from './faq.style.js'
import { Menus } from './index.jsx'
import { useAppConfig } from '~/hooks/useAppConfig.js'

const Plus = () => {
  const classes = useStyles()
  const appConfig = useAppConfig()
  const plusMembershipMinimun = appConfig.plusMembershipMinimum

  const specialTagMap = {
    red: {
      [JSONLD_TYPE]: (content) => content,
      [JSX_TYPE]: (content) => <span className={classes.red}>{content}</span>,
    },
    p: {
      [JSONLD_TYPE]: (content) => <p>{content}</p>,
      [JSX_TYPE]: (content) => (
        <Typography paragraph variant='body1'>
          {content}
        </Typography>
      ),
    },
    link: {
      [JSONLD_TYPE]: (content, url) => <a href={url}>{content}</a>,
      [JSX_TYPE]: (content, url) => (
        <a style={{ textDecoration: 'none' }} href={url}>
          {content}
        </a>
      ),
    },
  }

  const QAGenerator = (format) => [
    {
      question: 'What is Chowbus Plus?',
      answer: jsonLDHelpers.createFormattedAnswer(
        format,
        <>
          {specialTagMap.p[format](
            <>
              Chowbus Plus is our subscription service. For $9.99 a month, US and Canada subscribers
              receive free delivery{specialTagMap.red[format]('*')} on all orders from Chowbus when
              the subtotal of each order is greater than or equal to ${plusMembershipMinimun}. New
              York City subscribers can enjoy free delivery{specialTagMap.red[format]('*')} with no
              limit.
            </>
          )}
          {specialTagMap.p[format](
            <>
              All members will receive 10% off for pickup and exclusive delivery discount for
              certain restaurants. Visit{' '}
              {specialTagMap.link[format](
                'https://www.chowbus.com/chowbus-plus',
                'https://www.chowbus.com/chowbus-plus'
              )}{' '}
              for more information.{' '}
            </>
          )}
        </>
      ),
    },
    {
      question: 'Is there a free trial?',
      answer: jsonLDHelpers.createFormattedAnswer(
        format,
        <>
          {specialTagMap.p[format](
            'Yes! If this is your first time signing up for a Chowbus Plus membership, you will get a 30-day free trial. If you do not cancel your subscription at the end of the trial period, you will be charged a $9.99 monthly fee.'
          )}{' '}
        </>
      ),
    },
  ]

  const jsxQA = QAGenerator(JSX_TYPE)
  const jsonLDQA = jsonLDHelpers.createStructuredFAQData(
    QAGenerator(JSONLD_TYPE),
    'FAQs - Chowbus Plus'
  )
  return (
    <Page name='faq/plus'>
      <JSONLDHead jsonLD={jsonLDQA} />
      <AppToolBar />
      <Grid container justify='center' style={{ margin: '20px 0' }}>
        <Typography variant='h3'>FAQs</Typography>
      </Grid>
      <Grid container>
        <Grid item xs={12} md={2}>
          <Menus />
        </Grid>
        <Grid item xs={12} md={10}>
          <Typography paragraph variant='h5'>
            Chowbus Plus
          </Typography>
          {jsxQA.map(({ question, answer }, index) => (
            <div className={classes.section} key={index}>
              <Question question={question} />
              {answer}
            </div>
          ))}
          <div className={classes.section}>
            <Typography paragraph variant='body1'>
              Have another question that we didn’t answer here? Email questions to{' '}
              <EmailLink label='hello@chowbus.com' email='hello@chowbus.com' /> or tap “Help” inside
              of the Chowbus app.
            </Typography>
          </div>
          <div className={classes.section}>
            <Typography paragraph variant='body1'>
              <span className={classes.red}>
                *Additional fees may be applied if a delivery is over 10 miles.
              </span>
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Page>
  )
}

export default Plus
